<template>
  <Toast></Toast>
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '550px' }"
    :header="'Registrar Movimiento de Caja *** Cód: ' + ' ' + data_mov_caja.id"
    :modal="true"
    @hide="ocultarModal"
    class="p-fluid"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-3" v-if="mostrar_fecha_venta">
          <div class="p-inputgroup">
            <strong>FECHA:</strong>
            <Checkbox
              v-model="mov_fecha_diferente"
              :binary="true"
              v-tooltip.top="'Marque si la fecha es diferente a la actual'"
            />
          </div>
          <InputText
            :disabled="!mov_fecha_diferente"
            v-model="data_mov_caja.fecha_mov"
            type="date"
            :max="new Date().toISOString().split('T')[0]"
          />
        </div>
        <div
          :class="
            mostrar_fecha_venta
              ? 'field col-12 md:col-4'
              : 'field col-12 md:col-6'
          "
        >
          <span>
            <strong>T. MOVIMIENTO: </strong>
            <span class="p-invalid">*</span>
          </span>

          <Dropdown
            autofocus
            v-model="tipo_mov"
            :options="tp_movimientos"
            optionLabel="label"
            placeholder="Seleccione tipo Movimiento"
            @change="tipoMovChange"
          >
            <!-- Opciones en el dropdown -->
            <template #option="slotProps">
              <span
                :class="{
                  'product-badge status-instock': slotProps.option.value == 1,
                  'product-badge status-outofstock':
                    slotProps.option.value == 0,
                }"
              >
                {{ slotProps.option.label }}
              </span>
            </template>

            <!-- Valor seleccionado -->
            <template #value="slotProps">
              <span
                v-if="slotProps.value"
                :class="{
                  'product-badge status-instock': slotProps.value.value == 1,
                  'product-badge status-outofstock': slotProps.value.value == 0,
                }"
              >
                {{ slotProps.value.label }}
              </span>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
          </Dropdown>

          <small class="p-invalid" v-if="errors.tipo_mov">
            {{ errors.tipo_mov[0] }}
          </small>
        </div>

        <div
          :class="
            mostrar_fecha_venta
              ? 'field col-12 md:col-5'
              : 'field col-12 md:col-6'
          "
        >
          <span
            ><strong>AUTORIZADO POR: </strong>
            <span class="p-invalid">*</span></span
          >
          <InputText v-model="autorizado_por" />
          <small class="p-invalid" v-if="errors.autorizado_por">{{
            errors.autorizado_por[0]
          }}</small>
        </div>
        <div
          :class="
            metodo_pagoSelect == 1
              ? 'field col-12 md:col-6'
              : 'field col-12 md:col-4'
          "
        >
          <span
            ><strong>M&Eacute;TODO DE PAGO:</strong>
            <small class="p-invalid">*</small></span
          >
          <Dropdown
            v-model="metodo_pagoSelect"
            :options="metodo_pagos"
            optionLabel="nombre"
            class="w-full"
            optionValue="id"
            :disabled="tipo_mov.value == 0"
          />
        </div>
        <div class="field col-12 md:col-4" v-if="metodo_pagoSelect != 1">
          <span
            ><strong>{{ metodPagoNombre }}: </strong></span
          >
          <InputNumber
            v-model="importe_metodos_pagos"
            :minFractionDigits="2"
            mode="decimal"
            showButtons
            :inputClass="'text-right'"
            :min="0"
          />
        </div>
        <div
          :class="
            metodo_pagoSelect == 1
              ? 'field col-12 md:col-6'
              : 'field col-12 md:col-4'
          "
        >
          <span
            ><strong>IMPORTE EFECTIVO: </strong
            ><span class="p-invalid">*</span></span
          >
          <InputNumber
            inputClass="text-right"
            v-model="importe"
            :minFractionDigits="2"
            mode="decimal"
            :min="0"
            :showButtons="true"
            :max="mov_caja_caja ? data_mov_caja.calculo_total_saldo_caja : null"
          ></InputNumber>

          <small class="p-invalid" v-if="errors.importe">{{
            errors.importe[0]
          }}</small>
        </div>
        <div class="field col-12" v-if="metodo_pagoSelect != 1">
          <div v-if="imagenPreview" class="mt-3">
            <strong>Boucher cargado:</strong><br />
            <Image
              :src="'data:image/png;base64, ' + imagenPreview"
              width="150"
              preview
            ></Image>
          </div>
          <span><strong>ADJUNTAR BOUCHER:</strong></span>
          <FileUpload
            accept="image/*"
            name="boucher"
            :customUpload="true"
            @uploader="subirBoucher"
            mode="basic"
            label="Subir Boucher"
            chooseLabel="Seleccionar Imagen"
            :auto="true"
          />
        </div>
        <div
          v-if="'Caja Colectas' in auth.user.permissions && tipo_mov.value == 1"
          class="field col-12 md:col-12"
          style="
            text-align: center;
            border: 1px solid #ccc;
            padding: 10px;
            background-color: #f8f9fa;
            border-radius: 5px;
          "
        >
          <div class="p-inputgroup" v-if="!mov_caja_caja">
            <span><strong>¿ES COLECTA?</strong></span>
            <Checkbox
              v-model="data_mov_caja.campania"
              :binary="true"
              class="ml-1 mr-4"
              v-tooltip.top="
                'Marque si el movimiento es por concepto de colecta'
              "
              @change="noEsCampania"
            />
            <Dropdown
              v-if="data_mov_caja.campania"
              v-model="data_mov_caja.campania_id"
              :options="campanias"
              :filter="true"
              optionLabel="nombre"
              optionValue="id"
              placeholder="Seleccione Colecta"
              v-tooltip.top="
                'Seleccione la colecta a la que pertenece el movimiento'
              "
              @change="buscarDeudaCampania"
            />
          </div>

          <div
            v-if="data_mov_caja.campania && tipo_mov.value == 1"
            class="p-inputgroup mt-2"
          >
            <strong>APORTE PARROQUIA:</strong>
            <AutoComplete
              field="nombre"
              v-model="sucursalSelected"
              :suggestions="sucursales"
              placeholder="Buscar Parroquia"
              v-tooltip.top="'Buscar Parroquia'"
              @keyup.enter="buscarSucursal()"
              class="ml-1"
              @complete="buscarSucursal"
              @item-select="buscarDeudaCampania"
            >
              <template #item="slotProps">
                <div>
                  <strong>{{ slotProps.item.nombre }}</strong>
                </div>
              </template>
            </AutoComplete>
            <Button
              icon="pi pi-search"
              class="p-button-warning"
              v-tooltip.top="'Buscar Parroquia'"
              @click="buscarSucursal()"
            />
          </div>
          <div v-if="data_mov_caja.campania_id" class="deuda-campania-box">
            <div class="icono-alerta">⚠️</div>
            <div>
              <strong>Monto Estimado:</strong>
              <span class="monto-estimado mr-2">{{ monto }}</span>

              <strong>Total Aportado:</strong>
              <span class="monto-deuda">{{ deuda_campania }}</span>
            </div>
          </div>
          <!-- v-if="tipo_mov.value == 0 && !data_mov_caja.campania" -->
          <div v-if="false" class="p-inputgroup mt-4">
            <span><strong>TRANSFERIR CAJA?</strong></span>
            <Checkbox
              v-model="mov_caja_caja"
              :binary="true"
              class="ml-1 mr-4"
              v-tooltip.top="
                'Marque si desea realizar un movimiento de caja a caja'
              "
            />
            <Dropdown
              v-if="mov_caja_caja"
              v-model="cajaDestinariaSelected"
              :options="cajasDestinarias"
              optionLabel="nombre"
              optionValue="id"
              placeholder="Seleccione Caja Destino"
              v-tooltip.top="
                'Seleccione la caja destino para el movimiento de caja'
              "
            >
            </Dropdown>
            <small class="p-invalid" v-if="errors.cajaDestinariaSelected">{{
              errors.cajaDestinariaSelected[0]
            }}</small>
          </div>
          <div
            v-if="false"
            class="deuda-campania-box"
            style="justify-content: center; align-items: center"
          >
            <div class="icono-alerta" style="margin-top: 0">⚠️</div>
            <div>
              <strong
                >El monto por QR sera transferido a la caja seleccionada</strong
              >
              <br />
              <span
                >El total del monto a transferir es
                <span class="monto-estimado mr-2">{{
                  data_mov_caja.calculo_total_ventas_metodos_pago + importe
                }}</span>
              </span>
            </div>
          </div>
        </div>
        <div
          v-if="
            'Caja Servicios' in auth.user.permissions && tipo_mov.value == 0
          "
          class="field col-12 md:col-6"
        >
          <strong>CATEGORÍA:</strong>
          <Dropdown
            v-model="categoriaSelect"
            :options="categorias"
            optionLabel="servicio"
            placeholder="Seleccione una categoría..."
            @change="filtrarSubservicios"
            :filter="true"
          />
          <small class="p-invalid" v-if="errors.categoriaSelect">
            {{ errors.categoriaSelect[0] }}
          </small>
        </div>
        <div v-if="categoriaSelect" class="field col-12 md:col-6">
          <strong>SUBCATEGORÍA:</strong>
          <Dropdown
            v-model="subserviciosSelect"
            :options="subserviciosFiltrados"
            optionLabel="descripcion"
            placeholder="Seleccione un subservicio..."
            @change="nombre_subservicio = subserviciosSelect.descripcion"
            :filter="true"
          />
          <small class="p-invalid" v-if="errors.subserviciosSelect">
            {{ errors.subserviciosSelect[0] }}
          </small>
        </div>
        <div
          v-show="false"
          v-if="tipo_mov.value == 0"
          class="field col-12 md:12"
          style="
            text-align: center;
            border: 1px solid #ccc;
            padding: 10px;
            background-color: #f8f9fa;
            border-radius: 5px;
          "
        >
          <div class="p-inputgroup">
            <span><strong>¿ES ALMUERZO?</strong></span>
            <Checkbox
              v-model="data_mov_caja.almuerzo"
              :binary="true"
              class="ml-1 mr-4"
              @change="toggleSelection('almuerzo')"
              v-tooltip.top="
                'Marque si el movimiento es por concepto de almuerzo'
              "
            />
            <span><strong>¿ES COMISIÓN?</strong></span>
            <Checkbox
              v-model="data_mov_caja.comision"
              :binary="true"
              class="ml-1"
              @change="toggleSelection('comision')"
              v-tooltip.top="
                'Marque si el movimiento es por concepto de comisión'
              "
            />
          </div>
        </div>

        <div class="field col-12">
          <span
            ><strong v-if="data_mov_caja.almuerzo || data_mov_caja.comision"
              >PARA:</strong
            >
            <strong v-else>POR CONCEPTO DE: </strong>

            <span class="p-invalid">*</span></span
          >
          <Textarea
            v-model="concepto"
            rows="1"
            autoResize
            placeholder="Ingrese el concepto del movimiento de caja"
          />
          <small class="p-invalid" v-if="errors.concepto">{{
            errors.concepto[0]
          }}</small>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="field">
        <span class="flex md:justify-content-start"
          ><strong>CAMPOS REQUERIDOS: </strong>
          <span class="p-invalid">*</span></span
        >
      </div>
      <Button
        label="CANCELAR"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        @click="ocultarModal"
      />
      <Button
        label="GUARDAR"
        icon="pi pi-save"
        class="p-button-primary p-button-lg"
        @click="guardarMovCaja"
        :loading="enviado"
      />
    </template>
  </Dialog>
</template>
<script>
import CajaService from "@/service/CajaService";
import MetodoPagoService from "@/service/MetodoPagoService.js";
import UserService from "@/service/UserService";

export default {
  emits: ["closeModal", "actualizarListado"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    mov_caja: {
      type: Object,
      default() {
        return {};
      },
    },
    mostrar_fecha_venta: {
      type: Boolean,
      default: false,
    },
    campanias: {
      type: Array,
      default() {
        return [];
      },
    },
    subservicios: {
      type: Array,
      default() {
        return [];
      },
    },
    auth: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrarModal: this.show,
      data_mov_caja: this.mov_caja,
      data_subservicios: this.subservicios,
      enviado: false,
      errors: {},
      tipo_mov: { label: "INGRESO", value: 1 },
      tp_movimientos: [
        { label: "INGRESO", value: 1 },
        { label: "EGRESO", value: 0 },
      ],
      autorizado_por: "PROPIETARIO",
      importe: null,
      concepto: null,
      caja_id: null,
      metodo_pagoSelect: 1,
      metodo_pagos: [],
      importe_metodos_pagos: null,
      almuerzo: null,
      mov_fecha_diferente: false,
      imagenPreview: null,
      boucher_id: null,
      deuda_campania: 0,
      sucursalSelected: null,
      sucursales: [],
      monto: 0,
      debounceTimeout: null,
      mov_caja_caja: false,
      cajaDestinariaSelected: null,
      cajasDestinarias: [],
      subserviciosSelect: null,
      nombre_subservicio: null,

      categorias: [],
      categoriaSelect: null,
      subserviciosFiltrados: [],
    };
  },
  cajaService: null,
  metodoPagoService: null,
  userService: null,

  created() {
    this.cajaService = new CajaService();
    this.metodoPagoService = new MetodoPagoService();
    this.userService = new UserService();
  },
  mounted() {
    this.getMetodoPagos();
  },
  computed: {
    metodPagoNombre() {
      return this.metodo_pagos.find(
        (metodo) => metodo.id === this.metodo_pagoSelect
      ).nombre;
    },
  },
  methods: {
    filtrarSubservicios() {
      if (this.categoriaSelect) {
        this.subserviciosFiltrados = this.data_subservicios.filter(
          (s) => s.servicio === this.categoriaSelect.servicio
        );
        this.subserviciosSelect = null;
      }
    },
    buscarCajas(forceShow = false) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        const datos = {
          caja_id: this.data_mov_caja.id,
        };

        this.cajaService.buscarCajasMovimientos(datos).then((response) => {
          if (
            response.status === 400 ||
            !response.cajas ||
            response.cajas.length === 0
          ) {
            this.$toast.add({
              severity: "error",
              summary: "ERROR",
              detail: "No se encontraron Cajas",
              life: 3000,
            });
            this.cajasDestinarias = [];
            return;
          }

          this.cajasDestinarias = response.cajas.map((caja) => ({
            nombre: `caja: ${caja.id} - ${caja.nombre_usuario} - ${caja.sucursal}`,
            id: caja.id,
          }));

          if (this.cajasDestinarias.length === 1) {
            this.cajaDestinariaSelected = this.cajasDestinarias[0].id;
          }

          // 👇 Fuerza abrir el panel si no se escribió nada
          if (forceShow && this.$refs.autoComplete) {
            this.$refs.autoComplete.show();
          }
        });
      }, 500);
    },
    buscarSucursal() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        let datos = {
          texto: this.sucursalSelected ? this.sucursalSelected : null,
        };
        this.userService.buscar_sucursal_user(datos).then((response) => {
          if (response.status == 400 || response.sucursales.length == 0) {
            this.$toast.add({
              severity: "error",
              summary: "ERROR",
              detail: "No se encontraron Parroquias",
              life: 3000,
            });
            return;
          }
          this.sucursales = [...response.sucursales];
        });
      }, 500); // Espera 300ms antes de hacer la búsqueda
    },
    noEsCampania() {
      if (!this.data_mov_caja.campania) {
        this.data_mov_caja.campania_id = null;
        this.deuda_campania = 0;
        this.monto = 0;
        this.sucursalSelected = null;
      }
    },
    tipoMovChange() {
      if (this.tipo_mov.value == 1) {
        this.data_mov_caja.campania = false;
        this.data_mov_caja.campania_id = null;
      }
    },
    buscarDeudaCampania() {
      if (this.data_mov_caja.campania_id && this.tipo_mov.value == 0) {
        let datos = {
          campania_id: this.data_mov_caja.campania_id,
          sucursal_id: this.data_mov_caja.sucursal_id,
        };
        this.cajaService.getDeudaCampania(datos).then((res) => {
          this.deuda_campania = res.deuda_campania;
          this.monto = res.monto;
        });
      } else if (
        this.data_mov_caja.campania_id &&
        this.tipo_mov.value == 1 &&
        this.sucursalSelected
      ) {
        let datos = {
          campania_id: this.data_mov_caja.campania_id,
          sucursal_id: this.sucursalSelected.id,
        };
        this.cajaService.getDeudaCampania(datos).then((res) => {
          this.deuda_campania = res.deuda_campania;
          this.monto = res.monto;
        });
      } else {
        this.deuda_campania = 0;
      }
    },
    subirBoucher(event) {
      let archivo = event.files[0];
      let formData = new FormData();
      formData.append("imagen", archivo);

      this.cajaService.subirBoucher(formData).then((res) => {
        if (res.status == 200) {
          this.boucher_id = res.boucher_id; // Guarda este ID para asociar luego
          this.imagenPreview = res.imagen; // Mostrar vista previa de la imagen
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al subir el boucher",
            life: 3000,
          });
        }
      });
    },
    toggleSelection(field) {
      if (field === "almuerzo" && this.data_mov_caja.almuerzo) {
        this.data_mov_caja.comision = false;
      } else if (field === "comision" && this.data_mov_caja.comision) {
        this.data_mov_caja.almuerzo = false;
      }
    },
    getMetodoPagos() {
      this.metodoPagoService.getAllMetodoPagos().then((response) => {
        this.metodo_pagos = response.metodo_pagos;
      });
    },
    validacionFormulario() {
      if (!this.autorizado_por) {
        this.errors.autorizado_por = ["El campo autorizado por es requerido"];
      }
      if (!this.importe && this.metodo_pagoSelect == 1) {
        this.errors.importe = ["El campo importe es requerido"];
      }
      /* if (!this.concepto) {
        this.errors.concepto = ["El campo concepto es requerido"];
      } */

      if (this.tipo_mov.value == 0 && !this.subserviciosSelect) {
        if (!this.concepto) {
          this.errors.concepto = ["El campo concepto es requerido"];
        }
      } else if (this.tipo_mov.value != 0) {
        if (!this.concepto) {
          this.errors.concepto = ["El campo concepto es requerido"];
        }
      }
      if (this.metodo_pagoSelect != 1 && !this.importe_metodos_pagos) {
        this.errors.importe_metodos_pagos = ["El campo importe es requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },
    guardarMovCaja() {
      this.errors = {};
      if (this.enviado) return;
      if (!this.validacionFormulario()) {
        this.enviado = false;
        return;
      }
      if (
        this.data_mov_caja.campania_id &&
        parseInt(this.tipo_mov.value) === 1 &&
        (!this.sucursalSelected || !this.sucursalSelected.id)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Movimiento de Caja",
          detail: "Seleccione la Parroquia a la que pertenece el movimiento",
          life: 3000,
        });
        return;
      }

      let datos = {
        ...this.data_mov_caja,
        tipo_mov: this.tipo_mov.value,
        autorizado_por: this.autorizado_por,
        importe: this.importe ? this.importe : 0,
        concepto: this.concepto,
        caja_id: this.data_mov_caja.id,
        metodo_pago_id: this.metodo_pagoSelect,
        importe_metodos_pagos: this.importe_metodos_pagos
          ? this.importe_metodos_pagos
          : 0,
        mostrar_fecha_venta: this.mostrar_fecha_venta,
        mov_fecha_diferente: this.mov_fecha_diferente,
        boucher_id: this.boucher_id ? this.boucher_id : null,
        nombre_metodo_pago: this.metodo_pagos.find(
          (metodo) => metodo.id == this.metodo_pagoSelect
        ).nombre,
        sucursalSelected: this.sucursalSelected
          ? this.sucursalSelected.id
          : null,
        nombre_parroquia: this.sucursalSelected
          ? this.sucursalSelected.nombre
          : null,
        cajaDestinariaSelected: this.cajaDestinariaSelected ?? null,
        mov_caja_caja: this.mov_caja_caja,
        nombre_subservicio: this.nombre_subservicio,
        subservicio_id: this.subserviciosSelect
          ? this.subserviciosSelect.id
          : null,
      };
      this.enviado = true;

      this.cajaService.newMovimientoCaja(datos).then((data) => {
        if (Object.defineProperty.hasOwnProperty.call(data, "errors")) {
          this.errors = data.errors;
        } else {
          this.errors = {};
          if (data.success == false) {
            this.$toast.add({
              severity: "error",
              summary: "Movimiento de Caja",
              detail: data.mensaje,
              life: 3000,
            });
            this.enviado = false;
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Movimiento de Caja",
              detail: data.mensaje,
              life: 3000,
            });
            this.$emit("actualizarListado");
            this.ocultarModal();
            this.imprimirMovimientos(data.movimiento.id);
          }
        }
        this.enviado = false;
      });
    },
    imprimirMovimientos(id) {
      this.cajaService.imprimirMovimientosPDF(id).then(() => {});
    },
    ocultarModal() {
      this.errors = {};
      this.$emit("closeModal");
      this.metodo_pagoSelect = 1;
      this.importe = null;
      this.concepto = "";
      this.importe_metodos_pagos = null;
      this.data_mov_caja = {};
      this.data_mov_caja.campania = false;
      this.data_mov_caja.campania_id = null;
      this.deuda_campania = 0;
      this.sucursalSelected = null;
      this.mov_caja_caja = false;
      this.cajaDestinariaSelected = null;
      this.subserviciosSelect = null;
      this.nombre_subservicio = null;
      this.imagenPreview = null;
      this.boucher_id = null;
      this.mov_fecha_diferente = false;
      this.tipo_mov = { label: "INGRESO", value: 1 };
      this.autorizado_por = "PROPIETARIO";
      this.almuerzo = null;
      this.enviado = false;
      this.categoriaSelect = null;
      this.subserviciosFiltrados = [];
      this.subserviciosSelect = null;
    },
  },
  watch: {
    show(value) {
      this.mostrarModal = value;
    },
    mov_caja(value) {
      this.data_mov_caja = value;
    },
    subservicios(value) {
      this.data_subservicios = value;
      const categoriasUnicas = [];
      value.forEach((s) => {
        if (!categoriasUnicas.find((c) => c.servicio === s.servicio)) {
          categoriasUnicas.push({ servicio: s.servicio });
        }
      });
      this.categorias = categoriasUnicas;
    },
    /* mov_caja_caja(newVal) {
      if (newVal) {
        // Si se activa, rellena importe con el máximo permitido
        this.buscarCajas();
        this.importe = this.data_mov_caja.calculo_total_saldo_caja;
      } else {
        // Si se desactiva, puedes decidir si limpiar o mantener
        this.importe = null; // O comenta esta línea si quieres conservar el valor anterior
      }
    },
    tipo_mov(value) {
      if (value.value == 1) {
        this.mov_caja_caja = false;
      }
    }, */
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.p-invalid {
  color: red;
}

.deuda-campania-box {
  display: flex;
  align-items: flex-start;
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  border-left: 6px solid #f5c542;
  //padding: 12px 16px;
  border-radius: 6px;
  margin-top: 1rem;
  color: #856404;
  font-size: 14px;
}

.icono-alerta {
  font-size: 20px;
  margin-right: 12px;
  margin-top: 2px;
}

.monto-deuda {
  display: inline-block;
  background-color: #dc3545;
  color: white;
  font-weight: bold;
  padding: 0px 4px;
  border-radius: 4px;
  margin-left: 6px;
}

.monto-estimado {
  display: inline-block;
  background-color: #28a745;
  color: white;
  font-weight: bold;
  padding: 0px 4px;
  border-radius: 4px;
  margin-left: 6px;
}

.mensaje-aviso {
  display: block;
  margin-top: 4px;
  color: #721c24;
}

.caja-alerta-box {
  display: flex;
  align-items: center;
  background-color: #ffe6e6;
  border: 1px solid #ff4d4f;
  padding: 1rem;
  border-radius: 8px;
  color: #a8071a;
  margin-top: 1rem;
  font-size: 1rem;
}

.icono-alerta-roja {
  font-size: 2rem;
  margin-right: 1rem;
}

.texto-alerta-principal {
  font-size: 1.2rem;
  color: #a8071a;
}

.mensaje-aviso-rojo {
  color: #cf1322;
}
</style>
